// extracted by mini-css-extract-plugin
export default {"root":"ConnectData_root__NmOCT"};